import { Route, RouteObject } from "react-router-dom";
import MessagingLanding from "./components/MessagingLanding";
import ScheduledMessagesHistory from "./components/MessageHistory";
import ScheduledNotificationDetails from "./components/ScheduledMessageDetails";

export interface uxMessagingRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxMessagingRoute[];
}

export const uxMessagingRoutes: uxMessagingRoute[] = [
  {
    path: "communication-hub/messaging",
    element: <MessagingLanding />,
  },
  {
    // ✅ NEW ROUTE: For the scheduled messages page from messaging landing
    path: "communication-hub/scheduled-messages",
    element: <ScheduledMessagesHistory />,
  },
  {
    // ✅ ADD THIS: Details route for scheduled messages
    path: "communication-hub/scheduled-messages/scheduled/:notificationId",
    element: <ScheduledNotificationDetails />,
  },
];
